import Modal, { ModalHeader } from '@atlaskit/modal-dialog';
import InfoIcon from '@atlaskit/icon/glyph/info';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const styles = css({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.200'),
});
interface Props {
  recognitionSchedule?: {
    nextRefresh?: number | null;
  } | null;
  onClose: () => void;
}

const formatRefreshDate = (nextRefreshTimestamp?: number | null): string => {
  if (!nextRefreshTimestamp) return 'soon';

  const date = new Date(nextRefreshTimestamp);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

export const LimitReachedModal = ({ recognitionSchedule, onClose }: Props) => {
  const refreshDate = formatRefreshDate(recognitionSchedule?.nextRefresh);

  return (
    <Modal onClose={onClose} width="45rem">
      <div css={modalContainer}>
        <ModalHeader>
          <button type="button" css={closeButtonStyles} onClick={onClose}>
            <CrossIcon label="Close Modal" primaryColor={token('color.text')} />
          </button>
          <div css={headerContainer}>
            <div>
              <div css={styles}>
                <InfoIcon
                  label="Information"
                  size="large"
                  primaryColor={token('color.icon.information')}
                />
                <h3 css={titleStyles}>
                  {'You’ve reached your limit for this week.'}
                </h3>
              </div>
              <p css={bodyStyles}>
                {'Thanks for sharing the love! Come back on '}
                <span>{refreshDate}</span>
                {' to give more recognition.'}
              </p>
            </div>
          </div>
        </ModalHeader>
      </div>
    </Modal>
  );
};

const modalContainer = css({
  position: 'relative',
});

const headerContainer = css({
  display: 'flex',
  gap: token('space.200'),
  alignItems: 'flex-start',
  paddingTop: token('space.600'),
  paddingBottom: token('space.600'),
  paddingLeft: token('space.300'),
  paddingRight: token('space.300'),
});

const closeButtonStyles = css({
  position: 'absolute',
  right: '16px',
  top: '16px',
  border: 'none',
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
});

const titleStyles = css({
  color: token('color.text'),
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: 'var(--Font-Family-Heading, "Charlie Display")',
  fontSize: 'var(--Font-Heading-Size-H3-Heading, 2rem)',
  fontStyle: 'normal',
  fontWeight: 'var(--font-weight-semibold-600, 600)',
  lineHeight: 'var(--Font-Heading-Line-Height-H3-Heading, 2.5rem)',
  margin: 0,
  // marginBottom: token('space.200'),
});

const bodyStyles = css({
  color: token('color.text'),
  fontFamily: 'var(--Font-Family-Body, Inter)',
  fontSize: 'var(--Font-Body-Size-Large, 1.25rem)',
  fontStyle: 'normal',
  fontWeight: 'var(--font-weight-regular-400, 400)',
  lineHeight: 'var(--Font-Body-Line-Height-Large, 2rem)',
  margin: 0,
  marginLeft: token('space.600'),
});
